<template>
  <div>
    <div class="card-body py-0 mt-n2 mb-3 d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <base-input
          v-model="filterText"
          inputClasses="input-group-alternative form-control-sm"
          class="mb-0 mr-3"
          placeholder="Buscar"
          @input="onFilterTextBoxChanged"
        />
        <base-button
          @click="() => $router.push('/invoice/' + filterText)"
          v-if="showSearchDocNumBtn"
          size="sm"
        >
          Buscar por # Factura
        </base-button>
      </div>
      <base-button @click="syncStamped()" size="sm">
        Sincronizar Timbrado
      </base-button>
    </div>
    <ag-grid-vue
      style=" height: 70vh;"
      class="ag-theme-alpine mb-5"
      v-bind="agInvoices"
      @grid-ready="onGridReady"
      @cell-clicked="onCellClicked"
      @row-double-clicked="onRowDoubleClicked"
    />
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */

import { AgGridVue } from "ag-grid-vue";
import AgGrid from "@/mixins/AgGrid.js";
import Formats from "@/mixins/Formats";
import axios from "axios";
import moment from "moment";
import AgBadge from "@/components/AgGrid/AgBadge.vue";
import BaseLoader from "@/components/BaseLoader.vue";
import AgIcon from "@/components/AgGrid/AgIcon.vue";
import { AG_GRID_LOCALE_ES } from '@ag-grid-community/locale';
import CustomerAddress from "@/components/AgGrid/CustomerAddress.vue";
import { getAuth } from "firebase/auth";
import FilterDate from "@/components/AgGrid/Filters/FilterDate.vue";
import warehouses from "@/data/warehouses";


export default {
  mixins: [AgGrid, Formats],
  components: {
    AgGridVue,
    AgBadge,
    BaseLoader,
    AgIcon,
    CustomerAddress,
    agDateInput: FilterDate,

  },
  data() {
    return {
      gridApi: null,
      salesPersonOptions: null,
      showSearchDocNumBtn: null,
      filterText: null,
      stamping: null,
      approvalStampEmails: [
				'brendaterrazas@canplast.com.mx',
				'estefaniasalas@canplast.com.mx',
				'idalyvillalobos@canplast.com.mx',
				'alfredoreyes@canplast.com.mx',
        'leslysifuentes@canplast.com.mx'
			],
      agInvoices: {
        rowData: null,
        columnDefs: [
          {
            field: "U_WebError",
            headerName: "",
            width: 40,
            cellStyle: { textAlign: "center" },
            tooltipField: "U_WebError",
						filter: false,
						sortable: false,
            cellRendererSelector: () => {
              return {
                component: "AgIcon",
                params: {
                  color: "red",
                  icon: "fas fa-exclamation-circle",
                },
              };
            },
          },
          {
            colId: "stamp",
            headerName: "",
            sortable: false,
            filter: false,
            width: 60,
            cellClass: ({data}) => {
              if(data.canStamp && this.approvalStampEmails.includes(this.user.email) && !this.stamping){
                return "ag-clickable-cell text-blue font-weight-bold"
              } else {
                return "text-muted font-weight-bold";
              }
            },
            valueFormatter: ({data}) => {
              if(data.canStamp && this.approvalStampEmails.includes(this.user.email)){
                return this.stamping === data.DocNum ? "Timbrando..." : "Timbrar";
              } else {
                return null;
              }
            },
          },
          { 
            field: "DocNum", 
            headerName: "# Factura",
            width: 90,
            filter: "agTextColumnFilter", 
            cellClass: "ag-clickable-cell text-blue font-weight-bold",
          },
          {
            field: "CardName", 
            headerName: "Cliente", 
            width: 300,
            filter: "agTextColumnFilter", 
            cellRenderer: function ({data}) {
              return `
                <div>
                  <span class="font-weight-bold">${data.CardName}</span>
                  <span class="font-weight-normal">${data.CardCode}</span>
                </div>
              `;
            }
          },
          {
            field: "DocDate",
            headerName: "Fecha",
            width: 80,
            filter: "agDateColumnFilter",
            filterParams: {
              comparator: this.dateFilterComparator,
            },
          },
          {
            field: "DocDueDate",
            headerName: "Vencimiento",
            width: 100,
            filter: "agDateColumnFilter",
            filterParams: {
              comparator: this.dateFilterComparator,
            },
          },
          { 
            field: "U_Warehouse", 
            headerName: "Almacén",
            width: 80,
            filter: "agSetColumnFilter",
            filterParams: {
              values: warehouses,
              defaultToNothingSelected: true,
              applyMiniFilterWhileTyping: true,
            },
          },
          { 
            field: "SalesPerson", 
            headerName: "Vendedor",
            width: 120,
            filter: "agSetColumnFilter",
            filterParams: {
              values: (params) => params.success(this.salesPersonOptions.map((x) => x.SalesEmployeeName)),
              defaultToNothingSelected: true,
              applyMiniFilterWhileTyping: true,
            },
          },
          {
            field: "DocTotal",
            headerName: "Total",
            width: 120,
            filter: "agNumberColumnFilter",
            valueFormatter: ({data}) => this.currencyFormat(data.DocTotal, data.DocCurrency),
            headerClass: "ag-right-aligned-header",
            type: "rightAligned",
          },
          {
            field: "DocumentStatus",
            headerName: "Estatus",
            width: 80,
            filter: "agSetColumnFilter",
            filterParams: {
              values: ["bost_Open", "bost_Close"],
              valueFormatter: ({value}) => value === "bost_Open" ? "Abierta" : "Cerrada",
              defaultToNothingSelected: true,
              applyMiniFilterWhileTyping: true,
            },
            cellRendererSelector: ({value}) => {
              return {
                component: "AgBadge",
                params: {
                  text: value === "bost_Open" ? "Abierta" : "Cerrada",
                  color: value === "bost_Open" ? "#5e72e4" : "#adb5bd",
                },
              };
            },
          },
          {
            field: "Comments",
            headerName: "Comentarios",
            filter: "agTextColumnFilter", 
            width: 600,
          },
          {
            field: "shipping", 
            headerName: "Dirección", 
            filter: "agTextColumnFilter",
            width: 600,
            cellRenderer: function ({data}) {
              return `
                <div>
                  <span class="font-weight-bold">${data.ShipToCode}</span>
                  <span class="font-weight-normal">${data.Address2}</span>
                </div>
              `;
            }
          },
        ],
        defaultColDef: {
          menuTabs: ["filterMenuTab"],
          cellDataType: false,
          floatingFilter: true,
          suppressFloatingFilterButton: true,
        },
        loadingOverlayComponent: "BaseLoader",
        suppressCellFocus: true,
        enableCellTextSelection: true,
        cacheQuickFilter: true,
        pagination: true,
        tooltipShowDelay: 0,
        tooltipInteraction: true,
        localeText: AG_GRID_LOCALE_ES,
        alwaysShowVerticalScroll: true,
        rowSelection: "single",
      },
    };
  },

  created() {
    this.user = getAuth().currentUser;
    axios
      .get(`/api/sales_persons`)
      .then((response) => {
        this.salesPersonOptions = response.data.value;
        this.getInvoices();
      })
      .catch((error) => {
        console.error(error);
      });
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
    },
    getInvoices() {
      axios
        .get(`/api/invoices/errors`)
        .then((res) => {
          // console.log("UNSTAMPED INVOICES", res.data.value);
          this.agInvoices.rowData = res.data.value.map((x) => {

            let canStamp = true;
            if(
              (x.CardCode === 'C02858') ||
              (x.CardCode === 'C01100' && x.NumAtCard === 'MuestraCPM')
            ){
              canStamp = false;
            }

            return {
              DocEntry: x.DocEntry,
              DocNum: x.DocNum,
              CardName: x.CardName,
              CardCode: x.CardCode,
              customer: x.CardCode + ' ' + x.CardName,
              DocDate: moment(x.DocDate).format("YYYY-MM-DD"),
              DocDueDate: moment(x.DocDueDate).format("YYYY-MM-DD"),
              DocTotal:  parseFloat(x.DocCurrency === 'MXP' ? x.DocTotalSys : x.DocTotalFc),
              SalesPerson: this.salesPersonOptions.find(
                (y) => y.SalesEmployeeCode === x.SalesPersonCode
              ).SalesEmployeeName,
              DocumentStatus: x.DocumentStatus,
              U_WebError: x.U_WebError,
              U_Warehouse: x.U_Warehouse,
              DocCurrency: x.DocCurrency,
              ShipToCode: x.ShipToCode,
              Address2: x.Address2,
              shipping: x.ShipToCode + ' ' + x.Address2,
              Comments: x.Comments,
              canStamp: canStamp
            };
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    handleClick(data) {
      this.$router.push("/invoice/" + data.DocNum);
    },
    onCellClicked(params) {
      if (params.colDef.field === "DocNum") {
        this.handleClick(params.data);
      } else if(
        params.colDef.colId === "stamp" &&
        params.data.canStamp && 
        this.approvalStampEmails.includes(this.user.email) &&
        !this.stamping
      ) {
        this.stampInvoice(params)
      }
    },
    onRowDoubleClicked(params) {
      this.handleClick(params.data);
    },
    stampInvoice({data, api}) {
      if(data.canStamp && !this.stamping){
        this.stamping = data.DocNum;
        api.refreshCells({columns: ['stamp']});

        axios
          .post(`api/fpt/reinvoice?DocEntry=${data.DocEntry}`)
          .then((res) => {
            if(res.data.DocNum){
              this.$swal({
                title: "Factura Timbrada",
                text: `La factura ${res.data.DocNum} ha sido timbrada correctamente`,
                icon: "success",
              });
              this.getInvoices();
            } else if(res.data.msg){
              this.$swal({
                title: "Error",
                text: res.data.msg,
                icon: "error",
              });
            } else {
              console.error("Error", res.data)
              this.$swal({
                title: "Error",
                text: "Ocurrió un error al timbrar la factura",
                icon: "error",
              });
            }
          })
          .catch((err) => {
            console.error(err);
          })
          .finally(() => {
            this.stamping = null;
            api.refreshCells({columns: ['stamp']});
          });
      }
    },
    onFilterTextBoxChanged() {
      this.gridApi.setGridOption("quickFilterText", this.filterText);
      if (
        !this.gridApi.getDisplayedRowCount() &&
        this.filterText &&
        /^[0-9]+$/.test(this.filterText)
      ) {
        this.showSearchDocNumBtn = true;
      } else {
        this.showSearchDocNumBtn = false;
      }
    },
    syncStamped(){
      axios
        .post(`/api/fpt/missing_validated_invoices?date=2025-03-01`)
        .then((res) => {
          const {updated_success_invoices, updated_error_invoices, not_found_invoices} = res.data
          this.$swal({
          title: "Resultado de Sincronización",
          html: `
            <p><strong>Facturas Actualizadas con Éxito:</strong> ${updated_success_invoices.length > 0 ? updated_success_invoices.join(', '): 0}</p>
            <p><strong>Facturas No Encontradas:</strong> ${not_found_invoices.length > 0 ?not_found_invoices.join(', ') : 0}</p>
            <p><strong>Errores:</strong> ${updated_error_invoices.length > 0 ? updated_error_invoices.join(', ') : 0}</p>
          `,
          icon: "info",
        });
          
        }).catch(err=>{
          console.error(err);
          this.$swal({
            title: "Error de Sincronización",
            text: "Ocurrió un error al sincronizar las facturas timbradas",
            icon: "error"
          });
        })
    }
  },
};
</script>

<style lang="scss" scoped>
.ag-clickable-cell {
  cursor: pointer !important;
}
.ag-clickable-cell:hover {
  background: #e9ecef !important;
}
</style>
